import { detectEnvironment } from '@/lib/environment';

/**
 * Environment Badge Component
 *
 * Displays a visual indicator showing the current environment.
 * Only shows on non-production environments (dev, uat).
 */
export function EnvironmentBadge() {
  const env = detectEnvironment();

  // Don't show anything on production
  if (env === 'production') {
    return null;
  }

  // Environment-specific styles and labels
  const config = {
    development: {
      label: 'Development Environment',
      emoji: '🚧',
      bgColor: 'bg-yellow-500',
      textColor: 'text-black',
    },
    uat: {
      label: 'UAT Environment',
      emoji: '🧪',
      bgColor: 'bg-blue-500',
      textColor: 'text-white',
    },
  };

  const current = config[env];

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in">
      <div
        className={`${current.bgColor} ${current.textColor} px-4 py-2 rounded-lg font-semibold text-sm shadow-lg border-2 border-black/10`}
      >
        <span className="mr-2">{current.emoji}</span>
        {current.label}
      </div>
    </div>
  );
}
